import { Facebook, Instagram, Twitter, Youtube, MapPin, Phone, Mail, Clock } from 'lucide-react';
import logowhiteImage from './../styles/eyeslkm_white_ml.png';

interface FooterProps {
  onNavigate?: (page: string) => void;
}

export function Footer({ onNavigate }: FooterProps) {
  const handleNavClick = (page: string) => {
    if (onNavigate) {
      onNavigate(page);
      window.scrollTo(0, 0);
    }
  };
  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-8 mb-12">
          {/* Company Info */}
          <div className="space-y-4">
            {/* Logo */}
            <div className="flex items-center cursor-pointer" onClick={() => handleNavClick('home')}>
              <img 
                src={logowhiteImage} 
                alt="Eyes of a Child - LKM" 
                className="object-contain"
              />
            </div>
            <p className="text-gray-300 leading-relaxed">
              Creating joyful learning experiences for children through innovative programs 
              that foster creativity, curiosity, and confidence.
            </p>
            <div className="flex space-x-4">
              <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-700 cursor-pointer transition-colors">
                <Facebook className="w-5 h-5" />
              </div>
              <div className="w-10 h-10 bg-pink-600 rounded-full flex items-center justify-center hover:bg-pink-700 cursor-pointer transition-colors">
                <Instagram className="w-5 h-5" />
              </div>
              <div className="w-10 h-10 bg-blue-400 rounded-full flex items-center justify-center hover:bg-blue-500 cursor-pointer transition-colors">
                <Twitter className="w-5 h-5" />
              </div>
              <div className="w-10 h-10 bg-red-600 rounded-full flex items-center justify-center hover:bg-red-700 cursor-pointer transition-colors">
                <Youtube className="w-5 h-5" />
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><button onClick={() => handleNavClick('about')} className="text-gray-300 hover:text-white transition-colors">About Us</button></li>
              <li><button onClick={() => handleNavClick('programs')} className="text-gray-300 hover:text-white transition-colors">Our Programs</button></li>
              <li><button onClick={() => handleNavClick('about')} className="text-gray-300 hover:text-white transition-colors">Teachers</button></li>
              <li><button onClick={() => handleNavClick('contact')} className="text-gray-300 hover:text-white transition-colors">Admissions</button></li>
              <li><button onClick={() => handleNavClick('gallery')} className="text-gray-300 hover:text-white transition-colors">Gallery</button></li>
              <li><button onClick={() => handleNavClick('home')} className="text-gray-300 hover:text-white transition-colors">Events</button></li>
            </ul>
          </div>

          {/* Programs */}
          <div>
            <h3 className="text-lg font-bold mb-4">Programs</h3>
            <ul className="space-y-2">
              <li><button onClick={() => handleNavClick('programs')} className="text-gray-300 hover:text-white transition-colors">Creative Arts</button></li>
              <li><button onClick={() => handleNavClick('programs')} className="text-gray-300 hover:text-white transition-colors">Reading Adventures</button></li>
              <li><button onClick={() => handleNavClick('programs')} className="text-gray-300 hover:text-white transition-colors">Science Explorers</button></li>
              <li><button onClick={() => handleNavClick('programs')} className="text-gray-300 hover:text-white transition-colors">Music & Movement</button></li>
              <li><button onClick={() => handleNavClick('programs')} className="text-gray-300 hover:text-white transition-colors">Outdoor Play</button></li>
              <li><button onClick={() => handleNavClick('programs')} className="text-gray-300 hover:text-white transition-colors">Life Skills</button></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4">Contact Info</h3>
            <div className="space-y-3">
              <div className="flex items-start">
                <MapPin className="w-5 h-5 mr-3 mt-1 text-orange-400" />
                <div>
                  <p className="text-gray-300">2146 Kains Road</p>
                  <p className="text-gray-300">London, ON N6K0C1</p>
                </div>
              </div>
              <div className="flex items-center">
                <Phone className="w-5 h-5 mr-3 text-orange-400" />
                <p className="text-gray-300">(519) 472-4499</p>
              </div>
              <div className="flex items-center">
                <Mail className="w-5 h-5 mr-3 text-orange-400" />
                <p className="text-gray-300">info@eyeslkmontesorri.ca</p>
              </div>
              <div className="flex items-start">
                <Clock className="w-5 h-5 mr-3 mt-1 text-orange-400" />
                <div>
                  <p className="text-gray-300">Mon - Fri: 8:00 AM - 6:00 PM</p>
                  <p className="text-gray-300">Sat: 9:00 AM - 4:00 PM</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-300 text-sm">
              © 2025 Eyes Montessori London Kains. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a href="#" className="text-gray-300 hover:text-white text-sm transition-colors">Privacy Policy</a>
              <a href="#" className="text-gray-300 hover:text-white text-sm transition-colors">Terms of Service</a>
              <a href="#" className="text-gray-300 hover:text-white text-sm transition-colors">Cookie Policy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}